import { render } from "./Offers.vue?vue&type=template&id=0b410157&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"

import "./Offers.vue?vue&type=style&index=0&id=0b410157&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b410157"]])

export default __exports__